import { Injectable } from '@angular/core';
import {
  ApplyTrafficPeriod,
  ApplyTrafficPeriodFail,
  ApplyTrafficPeriodSuccess,
  FetchSelectableTrafficPeriods,
  FetchSelectableTrafficPeriodsFail,
  FetchSelectableTrafficPeriodsSuccess,
  TrafficPeriodSelectionActionTypes
} from '@app/pcs/actions/traffic-period-selection';
import { TrafficPeriod } from '@app/pcs/models';
import { createCalendar } from '@app/pcs/models/calendar.schema';
import * as fromPcs from '@app/pcs/reducer';
import { TrafficPeriodDataService } from '@app/pcs/services/traffic-period-data.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { mapPayload } from '@util';
import { of } from 'rxjs';
import { catchError, exhaustMap, switchMap } from 'rxjs/operators';

@Injectable()
export class TrafficPeriodSelectionEffects {

  fetchTrafficPeriods$ = createEffect(() => this.actions$.pipe(
    ofType<FetchSelectableTrafficPeriods>(TrafficPeriodSelectionActionTypes.FetchSelectableTrafficPeriods),
    mapPayload(),
    exhaustMap(ttpId =>
      this.trafficPeriodsDataService.fetchSelectableTrafficPeriods(ttpId).pipe(
        switchMap((trafficPeriods: TrafficPeriod[]) => of(new FetchSelectableTrafficPeriodsSuccess(trafficPeriods))),
        catchError(error => of(new FetchSelectableTrafficPeriodsFail(error)))
      )
    )
  ));

  applyTrafficPeriod$ = createEffect(() => this.actions$.pipe(
    ofType<ApplyTrafficPeriod>(TrafficPeriodSelectionActionTypes.ApplyTrafficPeriod),
    mapPayload(),
    exhaustMap(trafficPeriodId =>
      this.trafficPeriodsDataService.fetchTrafficPeriodById(trafficPeriodId).pipe(
        switchMap(({calendar}: TrafficPeriod) => of(new ApplyTrafficPeriodSuccess(createCalendar(calendar)))),
        catchError(error => of(new ApplyTrafficPeriodFail(error)))
      )
    )
  ));

  constructor(
    private store: Store<fromPcs.State>,
    private actions$: Actions,
    private trafficPeriodsDataService: TrafficPeriodDataService) {
  }
}
